import React, { useRef, useState } from "react";
import { Table, Button, Popconfirm, Tag } from "antd";
import moment from "moment";
import { getColumnSearchProps as columnSearchFn } from "../../utils/table";
import JobParameterElement from "./components/JobParameterElement";
import "../../views/SftpUI/styles.css";
// CSV Generator
import { ExportCSVSftp } from "../Common/ExportCSVSftp";

const JobTableElement = (props) => {
  const {
    handleDelete,
    scroll,
    className,
    dataSource,
    isLoadingDeleteJob,
    locale,
  } = props;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const getColumnSearchProps = columnSearchFn({
    searchInput,
    searchText,
    searchedColumn,
    setSearchText,
    setSearchedColumn,
  });

  // Table column list
  const columns = [
    {
      title: "Job ID",
      dataIndex: "_id",
      key: "_id",
      fixed: "left",
      width: "250px",
      ...getColumnSearchProps("_id"),
      sorter: (a, b) => (a._id ? a._id.localeCompare(b._id) : null),
    },
    {
      title: "Job Name",
      dataIndex: "jobName",
      key: "jobName",
      fixed: "left",
      width: "200px",
      ...getColumnSearchProps("jobName"),
      sorter: (a, b) => (a.jobName ? a.jobName.localeCompare(b.jobName) : null),
    },
    {
      title: "Enabled",
      dataIndex: "enabled",
      key: "enabled",
      width: "220px",
      ...getColumnSearchProps("enabled"),
      sorter: (a, b) =>
        (a.enabled ? "true" : "false").localeCompare(
          b.enabled ? "true" : "false",
        ),
      render: (idx, record) => {
        return <span>{record.enabled ? "true" : "false"}</span>;
      },
    },
    {
      title: "Schedules",
      dataIndex: "schedules",
      key: "schedules",
      width: "250px",
      render: (schedules) => (
        <span>
          {schedules.map((tag) => (
            <>
              <Tag
                color="blue"
                key={tag.cron}
                style={{ width: 200, marginBottom: 12 }}
              >
                Cron = {tag.cron}
              </Tag>
              <Tag color="blue" key={tag.description}>
                Description = {tag.description}
              </Tag>
            </>
          ))}
        </span>
      ),
    },
    {
      title: "Process Type",
      dataIndex: "processType",
      key: "processType",
      width: "200px",
      ...getColumnSearchProps("processType"),
      sorter: (a, b) =>
        a.processType ? a.processType.localeCompare(b.processType) : null,
    },
    {
      title: "Management Group Name",
      dataIndex: "managemetGroupName",
      key: "managemetGroupName",
      width: "200px",
      ...getColumnSearchProps("managemetGroupName"),
      sorter: (a, b) =>
        a.managemetGroupName
          ? a.managemetGroupName.localeCompare(b.managemetGroupName)
          : null,
      render: (idx, record) => (
        <span>
          {record.managemetGroupName
            ? record.managemetGroupName
            : "Not Available"}
        </span>
      ),
    },
    {
      title: "Project Id",
      dataIndex: "projectId",
      key: "projectId",
      width: "200px",
      ...getColumnSearchProps("projectId"),
      sorter: (a, b) =>
        a.projectId ? a.projectId.localeCompare(b.projectId) : null,
      render: (idx, record) => (
        <span>{record.projectId ? record.projectId : "Not Available"}</span>
      ),
    },
    {
      title: "Hotel Name",
      dataIndex: "hotelName",
      key: "hotelName",
      width: "200px",
      ...getColumnSearchProps("hotelName"),
      render: (idx, record) => (
        <span>{record.hotelName ? record.hotelName : "Not Available"}</span>
      ),
      sorter: (a, b) =>
        a.hotelName ? a.hotelName.localeCompare(b.hotelName) : null,
    },
    {
      title: "Hotel Code",
      dataIndex: "hotelCode",
      key: "hotelCode",
      width: "200px",
      ...getColumnSearchProps("hotelCode"),
      sorter: (a, b) =>
        a.hotelCode ? a.hotelCode.localeCompare(b.hotelCode) : null,
      render: (idx, record) => (
        <span>{record.hotelCode ? record.hotelCode : "Not Available"}</span>
      ),
    },
    {
      title: "Entity Id",
      dataIndex: "entityId",
      key: "entityId",
      width: "200px",
      ...getColumnSearchProps("entityId"),
      sorter: (a, b) =>
        a.entityId ? a.entityId.localeCompare(b.entityId) : null,
    },
    {
      title: "Time zone",
      dataIndex: "timezone",
      key: "timezone",
      width: "200px",
      ...getColumnSearchProps("timezone"),
      sorter: (a, b) =>
        a.timezone ? a.timezone.localeCompare(b.timezone) : null,
    },
    {
      title: "Delete Files From Source",
      dataIndex: "deleteFilesFromSource",
      key: "deleteFilesFromSource",
      width: "250px",
      ...getColumnSearchProps("deleteFilesFromSource"),
      render: (idx, record) => (
        <span>{record.deleteFilesFromSource ? "true" : "false"}</span>
      ),
      sorter: (a, b) =>
        (a.deleteFilesFromSource ? "true" : "false").localeCompare(
          b.deleteFilesFromSource ? "true" : "false",
        ),
    },
    {
      title: "Ignore Previous Status",
      dataIndex: "ignorePreviousStatus",
      key: "ignorePreviousStatus",
      width: "250px",
      ...getColumnSearchProps("ignorePreviousStatus"),
      render: (idx, record) => (
        <span>{record.ignorePreviousStatus ? "true" : "false"}</span>
      ),
      sorter: (a, b) =>
        (a.ignorePreviousStatus ? "true" : "false").localeCompare(
          b.ignorePreviousStatus ? "true" : "false",
        ),
    },
    {
      title: "Connections",
      dataIndex: "connections",
      key: "connections",
      width: "200px",
      ...getColumnSearchProps("connections"),
      sorter: (a, b) =>
        a.connections ? a.connections.localeCompare(b.connections) : null,
    },
    {
      title: "Job Parameters",
      dataIndex: "jobParameters",
      key: "jobParameters",
      width: "250px",
      render: (record) => <JobParameterElement jobParameters={record} />,
    },
    {
      title: "Root Path",
      dataIndex: "rootPath",
      key: "rootPath",
      width: "400px",
      render: (idx, record) => {
        return <span>{record.serverPath.rootPath}</span>;
      },
    },
    {
      title: "Created by",
      dataIndex: "create_by",
      key: "create_by",
      width: "200px",
      ...getColumnSearchProps("create_by"),
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      key: "create_at",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.create_at
            ? moment(record.create_at).local().format("YYYY-MM-DD HH:mm:ss")
            : ""}
        </span>
      ),
    },
    {
      title: "Updated by",
      dataIndex: "update_by",
      key: "update_by",
      width: "200px",
      ...getColumnSearchProps("update_by"),
    },
    {
      title: "Updated at",
      dataIndex: "update_at",
      key: "update_at",
      width: "200px",
      render: (_, record) => (
        <span>
          {record.update_at
            ? moment(record.update_at).local().format("YYYY-MM-DD HH:mm:ss")
            : ""}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      width: "150px",
      render: (_, record) => (
        <Popconfirm
          title="Sure To Delete?"
          onConfirm={() => handleDelete(record._id)}
        >
          <Button
            type="default"
            danger
            size="small"
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            disabled={isLoadingDeleteJob}
          >
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div className="is_table_3">
      <ExportCSVSftp
        csvData={dataSource}
        fileName="SFTP Job List"
        columnNames={columns}
      />
      <Table
        className="sm-custom-table-row-fixed"
        dataSource={dataSource}
        columns={columns}
        scroll={scroll}
        handleDelete={handleDelete}
        locale={locale}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
      />
    </div>
  );
};

export default JobTableElement;
